<cap-content-header>
  <cap-title>
    <span name="titleText">
      <span>{{ "GefundenePersonen" | translate: { rolle: (rolle === "ALLE" ? "berechtigtePersonen" : rolle) | translate } }} </span>
    </span>
  </cap-title>
  <cap-title-functionbar>
    @if (selectedIds.length >= 1) {
      <button
        (click)="onAuszug()"
        [disabled]="gbPrintService.zipInProgressMap.get(0)"
        class="btn btn-outline-primary btn-sm me-2"
        type="button">
        @if (gbPrintService.zipInProgressMap.get(0)) {
          <span class="spinner-border spinner-border-sm text-primary me-1"></span>
        }
        {{ "Auszüge" | translate }} {{ "(" + selectedIds.length + ")" }}
      </button>
    }
    <cap-functionbar-searchresult-buttons [listLoader]="listLoader"></cap-functionbar-searchresult-buttons>
  </cap-title-functionbar>
</cap-content-header>

<cap-list-loader (currentPageEventItem)="removeAllCheckboxes()" [listLoader]="listLoader">
  <div class="cap-list-loader-content">
    <table class="cap-table-search">
      <thead>
        <tr>
          <th>
            @if (listLoader?.items?.length > 1) {
              <input (click)="selectAllCheckboxes(listLoader?.items, $event.target)" id="selectAllCheckbox" name="cb" type="checkbox" />
            }
          </th>
          <th>
            <cap-column-header [columnName]="'Bezeichnung'" [sortModel]="tableSortModel.columns.get('personStammBezeichnung')">
            </cap-column-header>
          </th>
          <th>
            <cap-column-header [columnName]="'Art'" [sortModel]="tableSortModel.columns.get('personStammArt')"></cap-column-header>
          </th>
          <th>
            {{ "AdressenN" | translate }}
          </th>
          @if (rolle == "ALLE") {
            <th>
              {{ "Hinweis" | translate }}
            </th>
            <th>
              {{ "Eigentum" | translate }}
            </th>
            <th>
              {{ "UebrigeBerechtigte" | translate }}
            </th>
            <th>
              {{ "Glaeubiger" | translate }}
            </th>
            <th>
              {{ "Schuldner" | translate }}
            </th>
          }
          @if (rolle == "EIGENTUEMER") {
            <th>
              {{ "Auszug" | translate }}
            </th>
          }
        </tr>
      </thead>
      <tbody>
        @for (item of sortedRelevantList; track item; let indexOfElement = $index) {
          <tr>
            <td>
              @if (listLoader?.items?.length > 0) {
                <input
                  (click)="addCheckedPerson(item.masterId.id, $event.target)"
                  [checked]="selectedIds.includes(item.masterId.id)"
                  id="inlineCheckbox2_+{{ indexOfElement }}"
                  name="cb"
                  type="checkbox" />
              }
            </td>
            <td>
              <cap-link
                [enableNavigation]="showPersonendaten(item.auskunftsperre)"
                [params]="[item.masterId.id, item.version.id?.id]"
                [target]="getNavTarget().get(rolle)"
                [tooltipParams]="item | tooltipPersonstammPipe">
                <cap-kompakt-stammperson [auskunftsperre]="item.auskunftsperre" [item]="item.version"></cap-kompakt-stammperson>
              </cap-link>
            </td>
            <td>
              @if (showPersonendaten(item.auskunftsperre)) {
                <cap-link
                  [params]="[item.masterId.id, item.version.id?.id]"
                  [target]="getNavTarget().get(rolle)"
                  [tooltipParams]="item | tooltipPersonstammPipe">
                  {{ item.version.art | translate }}
                </cap-link>
              }
            </td>
            <td>
              @if (showAdressen(item.auskunftsperre)) {
                @for (adresse of item.adressen; track adresse; let i = $index) {
                  <ng-Container>
                    <cap-kompakt-personenadresse
                      [auskunftsperre]="item.auskunftsperre"
                      [entry]="item.version"
                      [item]="adresse"
                      [link]="{
                        target: getNavTarget().get(rolle),
                        params: [item.masterId.id, item.version.id?.id],
                        tooltipParams: item | tooltipPersonstammPipe
                      }">
                    </cap-kompakt-personenadresse>
                    @if (i < item.adressen.length - 1) {
                      <br />
                    }
                  </ng-Container>
                }
              } @else {
                <div>
                  <span style="font-style: italic">{{ "stammperson-adresssperre" | translate }}</span>
                </div>
              }
            </td>
            @if (rolle == "ALLE") {
              <td>
                @if (item.diffHint) {
                  <span [ngbTooltip]="'personDiffHint' | translate" placement="bottom-right">
                    <i class="fas fa-info-circle fa-2x"></i>
                  </span>
                }
              </td>
              <td>
                <cap-person-rolle-count
                  [fieldMetaData]="item.mEigentumCount"
                  [personRolleCount]="item.eigentumCount"></cap-person-rolle-count>
              </td>
              <td>
                <cap-person-rolle-count
                  [fieldMetaData]="item.mUebrigeBerechtigteCount"
                  [personRolleCount]="item.uebrigeBerechtigteCount"></cap-person-rolle-count>
              </td>
              <td>
                <cap-person-rolle-count
                  [fieldMetaData]="item.mGlaeubigerCount"
                  [personRolleCount]="item.glaeubigerCount"></cap-person-rolle-count>
              </td>
              <td>
                <cap-person-rolle-count
                  [fieldMetaData]="item.mSchuldnerCount"
                  [personRolleCount]="item.schuldnerCount"></cap-person-rolle-count>
              </td>
            }
            @if (rolle == "EIGENTUEMER") {
              <td>
                <cap-auszug [item]="item"></cap-auszug>
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>
</cap-list-loader>
